function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const parts = path.split(".");
  let cur = obj;
  for (let i = 0; i < parts.length; i += 1) {
    const key = parts[i];
    if (cur == null || typeof cur !== "object") return undefined;
    cur = cur[key];
  }
  return cur;
}

export function validateProjectPageComponentEditForm(current) {
  const errs = {};
  if (!current || typeof current !== "object") return errs;

  // Field label mapping
  const fieldLabels = {
    "info.projectPageId": "Project Page",
    "info.componentOrder": "Component Order",
    "content.buttonType1": "Button Type 1",
    "content.buttonType2": "Button Type 2",
  };

  // Required fields
  const required = ["info.projectPageId", "info.componentOrder"];
  required.forEach((path) => {
    const v = getByPath(current, path);
    if (v === undefined || String(v).trim() === "") {
      errs[path] = `${fieldLabels[path]}: This field is required`;
    }
  });

  // Component order must be integer if provided
  const order = getByPath(current, "info.componentOrder");
  if (order !== undefined && order !== null && String(order) !== "") {
    const n = Number(order);
    if (!Number.isInteger(n))
      errs["info.componentOrder"] =
        `${fieldLabels["info.componentOrder"]}: Must be an integer`;
  }

  return errs;
}
